import React from "react";

export default function Landing() {

	return(
		<div className="text-center mx-2 md:mx-20 lg:mx-32 shadow-lg align-middle justify-center my-20 py-20 rounded-2xl">
			<h1>Welcome!</h1>
			<p className="font-semibold text-lg">This site is <strong>under construction</strong> and will likely contain bugs and missing features.</p>
			<div className="w-64 justify-center text-center mx-auto"><hr /></div>
			<p>Please use the buttons above to navigate.</p>
		</div>
	)
}